"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _each2 = _interopRequireDefault(require("lodash/each"));

var _difference2 = _interopRequireDefault(require("lodash/difference"));

var _union2 = _interopRequireDefault(require("lodash/union"));

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _values2 = _interopRequireDefault(require("lodash/values"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

var _Link = _interopRequireDefault(require("../Typography/Link"));

var _Input = _interopRequireDefault(require("../Input/Input"));

var _TableBody = _interopRequireDefault(require("./TableBody"));

var _TableHeader = _interopRequireDefault(require("./TableHeader"));

var _TableColGroup = _interopRequireDefault(require("./TableColGroup"));

var _Pagination = _interopRequireDefault(require("../Navigation/Pagination"));

var _Sorter = _interopRequireDefault(require("../Sorter/Sorter"));

var _TableRowSelection = require("./TableRowSelection");

var _TableCell = require("./TableCell");

var _TableConstants = _interopRequireDefault(require("./TableConstants"));

var _ValidationUtil = _interopRequireDefault(require("../../../utils/v2/ValidationUtil"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _Title = _interopRequireDefault(require("../Typography/Title"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Table component
 */
var Table =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));

    _this.handleRefreshData = function () {
      if (_this.props.onRefreshData) {
        _this.props.onRefreshData({
          loading: true,
          loadingError: false
        });
      }
    };

    _this.handleScroll = function (event) {
      if (event.target.scrollTop !== _this.state.scrollTop) {
        _this.setState({
          scrollTop: event.target.scrollTop
        });
      }

      if (_this.props.structure && _this.props.structure.bodyMaxWidth && _this.tableHeaderRef) {
        // Table header is a separate table so synchronize horizontal scroll of table body
        _this.tableHeaderRef.current.scrollLeft = event.target.scrollLeft;
      }
    };

    _this.handleColumnResize = function (structure) {
      if (_this.props.onChangeStructure) {
        _this.props.onChangeStructure(structure);
      }
    };

    _this.handlePageChange = function (nextPage, pageSize) {
      if (_this.props.onChangePagination) {
        var pagination = (0, _cloneDeep2.default)(_this.props.pagination);
        pagination.currentPage = nextPage;
        pagination.pageSize = pageSize;

        _this.props.onChangePagination(pagination, nextPage, pageSize);
      }
    };

    _this.handleEditDataChange = function (value, rowData, column, eventType) {
      var _this$props = _this.props,
          columnKey = _this$props.columnKey,
          dataSource = _this$props.dataSource,
          editDirect = _this$props.editDirect,
          editRow = _this$props.editRow;

      if (editRow) {
        if (!_this.initialDataSource) {
          _this.initialDataSource = (0, _cloneDeep2.default)(dataSource);
        } // If edit row mode, store the row data until user submits the change


        _this.editRowData = _this.editRowData || (0, _cloneDeep2.default)(rowData);
        _this.editRowData[column[columnKey]] = value;
      } else if (editDirect) {
        _this._handleEditDirectDataChange(value, rowData, column, eventType);
      }
    };

    _this.handleEditRowCancelClick = function () {
      var editRow = (0, _cloneDeep2.default)(_this.props.editRow);
      editRow.row = null; // Cancelling should empty out the cell alerts

      var cellAlerts = [];

      if (_this.props.onClickEditRowCancel) {
        var dataSource = _this.initialDataSource || _this.props.dataSource;

        _this.props.onClickEditRowCancel(dataSource, editRow, cellAlerts);
      }

      _this.editRowData = null;
      _this.initialDataSource = null;
    };

    _this.handleEditRowSubmitClick = function () {
      var isValidInput = true;
      var cellAlerts = [];
      var newRow;
      var newData = (0, _cloneDeep2.default)(_this.props.dataSource);

      if (_this.editRowData) {
        newRow = _objectSpread({}, _this.editRowData);
        cellAlerts = _this._getErrorAlertsForRow(newRow);

        if (cellAlerts.length) {
          isValidInput = false;
        } // Update newData with newRow data after validation passes


        var rowKey = _this.props.rowKey;

        for (var i = 0; i < newData.length; i++) {
          if (newData[i][rowKey] === newRow[rowKey]) {
            newData[i] = newRow;
            break;
          }
        }
      }

      var editRow = (0, _cloneDeep2.default)(_this.props.editRow);

      if (isValidInput) {
        editRow.row = null;
        _this.editRowData = null;
        _this.initialDataSource = null;
      }

      if (_this.props.onClickEditRowSubmit) {
        // Send new data source with updated row, editRow object for unfocusing the row,
        // cellAlerts object for updated alerts and update row data
        _this.props.onClickEditRowSubmit(newData, editRow, cellAlerts, newRow);
      }
    };

    _this.handleRowExpandChange = function (rowKeyVal) {
      if (_this.props.onChangeRowExpand) {
        var rowExpand = (0, _cloneDeep2.default)(_this.props.rowExpand);
        rowExpand.rows = rowExpand.rows || [];
        var isExpanded = rowExpand && rowExpand.rows.indexOf(rowKeyVal) >= 0;

        if (isExpanded) {
          rowExpand.rows.splice(rowExpand.rows.indexOf(rowKeyVal), 1);

          _this.props.onChangeRowExpand(rowExpand, null, rowKeyVal);
        } else {
          rowExpand.rows.push(rowKeyVal);

          _this.props.onChangeRowExpand(rowExpand, rowKeyVal, null);
        }
      }
    };

    _this.handleRowSelect = function (e, rowKeyVal, rowIndex) {
      if (_this.props.onChangeRowSelection) {
        var rowSelection = (0, _cloneDeep2.default)(_this.props.rowSelection);
        var newSelectedRows = [rowKeyVal];
        rowSelection.selected.push(rowKeyVal); // If shift key is being pressed while a row is selected, we will select
        // all the rows in between the current selected row and the last row
        // that had a selection action done (this.shiftClickRowIndex)

        if (e.nativeEvent && e.nativeEvent.shiftKey) {
          newSelectedRows = _this._getShiftClickRows(rowIndex);
          rowSelection.selected = (0, _union2.default)(rowSelection.selected, newSelectedRows);
        }

        _this.shiftClickRowIndex = rowIndex;

        _this.props.onChangeRowSelection(rowSelection, newSelectedRows, []);
      }
    };

    _this.handleRowUnselect = function (e, rowKeyVal, rowIndex) {
      if (_this.props.onChangeRowSelection) {
        var rowSelection = (0, _cloneDeep2.default)(_this.props.rowSelection);
        var newUnselectedRows = [rowKeyVal];
        rowSelection.selected.splice(rowSelection.selected.indexOf(rowKeyVal), 1); // If shift key is being pressed while a row is unselected, we will
        // unselect all the rows in between the current unselected row and the
        // last row that had a selection action done (this.shiftClickRowIndex)

        if (e.nativeEvent && e.nativeEvent.shiftKey) {
          newUnselectedRows = _this._getShiftClickRows(rowIndex);
          rowSelection.selected = (0, _difference2.default)(rowSelection.selected, newUnselectedRows);
        }

        _this.shiftClickRowIndex = rowIndex;

        _this.props.onChangeRowSelection(rowSelection, [], newUnselectedRows);
      }
    };

    _this.handleRowSelectOne = function (rowKeyVal) {
      var onChangeRowSelection = _this.props.onChangeRowSelection;

      if (onChangeRowSelection) {
        var rowSelection = (0, _cloneDeep2.default)(_this.props.rowSelection);
        var selected = [rowKeyVal];
        var unselected = [];

        if (rowSelection && rowSelection.selected) {
          unselected = rowSelection.selected.slice(0);
        }

        rowSelection.selected = selected;
        onChangeRowSelection(rowSelection, selected, unselected);
      }
    };

    _this.handleRowSelectAll = function (rowKeys) {
      var onChangeRowSelection = _this.props.onChangeRowSelection;

      if (onChangeRowSelection) {
        var rowSelection = (0, _cloneDeep2.default)(_this.props.rowSelection);
        var selected = rowSelection.selected || [];
        var newlySelected = [];

        for (var i = 0; i < rowKeys.length; i++) {
          if (selected.indexOf(rowKeys[i]) === -1) {
            newlySelected.push(rowKeys[i]);
          }
        }

        rowSelection.selected = selected.concat(newlySelected);
        _this.shiftClickRowIndex = 0;
        onChangeRowSelection(rowSelection, newlySelected, []);
      }
    };

    _this.handleRowUnselectAll = function (rowKeys) {
      var onChangeRowSelection = _this.props.onChangeRowSelection;

      if (onChangeRowSelection) {
        var rowSelection = (0, _cloneDeep2.default)(_this.props.rowSelection);
        var selected = rowSelection.selected || [];
        var unselected = rowKeys; // Remove the rows from selected array that are in unselected array

        for (var i = selected.length - 1; i >= 0; i--) {
          if (unselected.indexOf(selected[i]) >= 0) {
            selected.splice(i, 1);
          }
        }

        rowSelection.selected = selected;
        _this.shiftClickRowIndex = 0;
        onChangeRowSelection(rowSelection, [], unselected);
      }
    };

    _this.handleSortOrderChange = function (order, column) {
      if (_this.props.onChangeSort) {
        var sort = (0, _cloneDeep2.default)(_this.props.sort);
        sort.order = order;
        sort.column = column;

        _this.props.onChangeSort(sort, order, column);
      }
    };

    _this.eventHandlers = {
      handleColumnResize: _this.handleColumnResize,
      handlePageChange: _this.handlePageChange,
      handleEditDataChange: _this.handleEditDataChange,
      handleEditRowCancelClick: _this.handleEditRowCancelClick,
      handleEditRowSubmitClick: _this.handleEditRowSubmitClick,
      handleRefreshData: _this.handleRefreshData,
      handleRowExpandChange: _this.handleRowExpandChange,
      handleRowSelectAll: _this.handleRowSelectAll,
      handleRowSelectOne: _this.handleRowSelectOne,
      handleRowSelect: _this.handleRowSelect,
      handleRowUnselectAll: _this.handleRowUnselectAll,
      handleRowUnselect: _this.handleRowUnselect,
      handleSortOrderChange: _this.handleSortOrderChange
    };
    _this.tableHeaderRef = _react.default.createRef(); // Default shift click row index to row at the top of the table

    _this.shiftClickRowIndex = 0;
    _this.state = {
      scrollTop: 0
    };
    return _this;
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          border = _this$props2.border,
          className = _this$props2.className,
          columns = _this$props2.columns,
          customMessages = _this$props2.customMessages,
          dataSource = _this$props2.dataSource,
          loading = _this$props2.loading,
          loadingError = _this$props2.loadingError,
          search = _this$props2.search,
          structure = _this$props2.structure; // Before attempting to render anything, make sure the data has the expected
      // column and row keys

      this.validateKeys();
      var mainSection = [];
      var hasData = columns.length > 0 && dataSource.length > 0; // If search is enabled, we should render the header so the table
      // doesn't jump when all data is filtered out from the search (No data state)

      if ((search || hasData) && !(structure && structure.hideHeader)) {
        mainSection.push(this.renderTableHeader());
      }

      if (search) {
        mainSection.push(this.renderSearch());
      }

      var tableBody;

      if (hasData) {
        tableBody = this.renderTableBody();
      } else {
        tableBody = this.renderNoData();
      }

      mainSection.push(tableBody);

      if (loadingError) {
        mainSection.push(this.renderErrorMessage());
      } else if (loading) {
        var loadingMessage = customMessages && customMessages.loadingMessage ? customMessages.loadingMessage : _I18nManager.default.t('Table', 'loading');
        mainSection = [_react.default.createElement(_Loader.default, {
          key: "tableLoader",
          tip: loadingMessage
        }, mainSection)];
      }

      var tableContent = [];
      var topSection = this.renderTopSection();

      if (topSection) {
        tableContent.push(topSection);
      }

      tableContent.push(_react.default.createElement("div", {
        key: "tableMainSection",
        className: (0, _classnames.default)('table-main-section', !hasData ? 'no-data' : '')
      }, mainSection));
      var bottomSection = this.renderBottomSection();

      if (bottomSection) {
        tableContent.push(bottomSection);
      }

      var maxWidth = structure && structure.bodyMaxWidth ? structure.bodyMaxWidth : 'none';
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), " ").concat(_ThemeManager.default.getVar('classPrefix'), "-table")),
        "data-border": border,
        "data-fixed-header": Boolean(structure && structure.bodyMaxHeight),
        "data-scrolling": Boolean(this.state.scrollTop),
        style: {
          maxWidth: maxWidth
        }
      }, tableContent);
    }
    /**
     * Render section on top of table
     * @returns {ReactElement} - Element to render on top of the table
     */

  }, {
    key: "renderTopSection",
    value: function renderTopSection() {
      var _this$props3 = this.props,
          topSection = _this$props3.topSection,
          pagination = _this$props3.pagination,
          structure = _this$props3.structure;
      var leftContent = [];
      var rightContent = [];

      if (topSection) {
        if (topSection.title) {
          leftContent.push(_react.default.createElement(_Title.default, {
            key: "tableTitle",
            size: "h3"
          }, topSection.title));
        }

        if (topSection.leftContent) {
          leftContent.push(_react.default.createElement("div", {
            key: "topLeftTableContent"
          }, topSection.leftContent));
        }

        if (topSection.rightContent) {
          rightContent.push(_react.default.createElement("div", {
            key: "topRightTableContent"
          }, topSection.rightContent));
        }
      }

      if (pagination && structure && structure.paginationPosition && structure.paginationPosition.top) {
        rightContent.push(this.renderPagination());
      }

      var content = null;

      if (leftContent.length && rightContent.length) {
        content = _react.default.createElement(_FlexLayout.default, {
          justifyContent: "space-between"
        }, _react.default.createElement(_FlexLayout.default, null, leftContent), _react.default.createElement(_FlexLayout.default, null, rightContent));
      } else if (rightContent.length) {
        content = _react.default.createElement(_FlexLayout.default, {
          flexDirection: "row-reverse"
        }, rightContent);
      } else if (leftContent.length) {
        content = _react.default.createElement(_FlexLayout.default, null, leftContent);
      }

      if (!content) {
        return null;
      }

      return _react.default.createElement("div", {
        key: "tableTopSection",
        className: "table-top-section"
      }, content);
    }
    /**
     * Render section on bottom of table
     * @returns {ReactElement} - Element to render on bottom of the table
     */

  }, {
    key: "renderBottomSection",
    value: function renderBottomSection() {
      var _this$props4 = this.props,
          pagination = _this$props4.pagination,
          structure = _this$props4.structure;
      var content = null; // Rendering pagination at the bottom should be default if pagination
      // is defined, but position is not

      if (pagination && (!structure || !structure.paginationPosition || structure.paginationPosition.bottom)) {
        content = _react.default.createElement(_FlexLayout.default, {
          flexDirection: "row-reverse"
        }, this.renderPagination());
      }

      if (!content) {
        return null;
      }

      return _react.default.createElement("div", {
        key: "tableBottomSection",
        className: "table-bottom-section"
      }, content);
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      var customMessages = this.props.customMessages; // todo: i18n

      var errorMessage = _I18nManager.default.t('Table', 'loading_error');

      var defaultErrorContent = [_react.default.createElement("div", {
        key: "defaultErrorMsg"
      }, errorMessage), _react.default.createElement(_Link.default, {
        key: "retryLink",
        className: "retry-link",
        onClick: this.handleRefreshData
      }, _I18nManager.default.t('Table', 'retry'))];
      var errorContent = customMessages && customMessages.loadingError ? customMessages.loadingError : defaultErrorContent;
      return _react.default.createElement("div", {
        key: "errorMessage",
        className: "error-message"
      }, errorContent);
    }
  }, {
    key: "renderNoData",
    value: function renderNoData() {
      var customMessages = this.props.customMessages;
      var noDataMessage = customMessages && customMessages.noData ? customMessages.noData : _I18nManager.default.t('Table', 'no_data');
      return _react.default.createElement("div", {
        key: "noDataMessage",
        className: "no-data-message"
      }, noDataMessage);
    }
  }, {
    key: "renderTableColGroup",
    value: function renderTableColGroup() {
      var _this$props5 = this.props,
          columnKey = _this$props5.columnKey,
          columns = _this$props5.columns,
          editRow = _this$props5.editRow,
          rowAction = _this$props5.rowAction,
          rowExpand = _this$props5.rowExpand,
          rowSelection = _this$props5.rowSelection,
          structure = _this$props5.structure;
      return _react.default.createElement(_TableColGroup.default, {
        columnKey: columnKey,
        columns: columns,
        editRow: editRow,
        rowAction: rowAction,
        rowExpand: rowExpand,
        rowSelection: rowSelection,
        structure: structure
      });
    }
  }, {
    key: "renderTableHeader",
    value: function renderTableHeader() {
      var _this$props6 = this.props,
          columnKey = _this$props6.columnKey,
          columns = _this$props6.columns,
          customProps = _this$props6.customProps,
          dataSource = _this$props6.dataSource,
          editRow = _this$props6.editRow,
          rowAction = _this$props6.rowAction,
          rowExpand = _this$props6.rowExpand,
          rowKey = _this$props6.rowKey,
          rowSelection = _this$props6.rowSelection,
          sort = _this$props6.sort,
          structure = _this$props6.structure;
      return _react.default.createElement("div", {
        key: "tableHeader",
        className: "table-header",
        ref: this.tableHeaderRef
      }, _react.default.createElement("table", null, this.renderTableColGroup(), _react.default.createElement(_TableHeader.default, {
        columnKey: columnKey,
        columns: columns,
        customProps: customProps,
        dataSource: dataSource,
        editRow: editRow,
        eventHandlers: this.eventHandlers,
        rowAction: rowAction,
        rowExpand: rowExpand,
        rowKey: rowKey,
        rowSelection: rowSelection,
        sort: sort,
        structure: structure
      })));
    }
  }, {
    key: "renderTableBody",
    value: function renderTableBody() {
      var _this$props7 = this.props,
          cellAlerts = _this$props7.cellAlerts,
          columnKey = _this$props7.columnKey,
          columns = _this$props7.columns,
          customProps = _this$props7.customProps,
          dataSource = _this$props7.dataSource,
          editDirect = _this$props7.editDirect,
          editRow = _this$props7.editRow,
          rowAction = _this$props7.rowAction,
          rowAlerts = _this$props7.rowAlerts,
          rowExpand = _this$props7.rowExpand,
          rowKey = _this$props7.rowKey,
          rowSelection = _this$props7.rowSelection,
          _this$props7$structur = _this$props7.structure,
          structure = _this$props7$structur === void 0 ? {} : _this$props7$structur;
      var fixedHeader = Boolean(structure.bodyMaxHeight);
      var hasMaxWidth = Boolean(structure.bodyMaxWidth);
      var hasRowFocus = Boolean(editRow && editRow.row);
      return _react.default.createElement("div", {
        key: "tableBody",
        className: (0, _classnames.default)('table-body', hasRowFocus ? 'has-row-focus' : ''),
        style: {
          maxHeight: fixedHeader ? structure.bodyMaxHeight : 'none',
          maxWidth: hasMaxWidth ? structure.bodyMaxWidth : 'none'
        },
        onScroll: this.handleScroll
      }, _react.default.createElement("table", null, this.renderTableColGroup(), _react.default.createElement(_TableBody.default, {
        cellAlerts: cellAlerts,
        columnKey: columnKey,
        columns: columns,
        customProps: customProps,
        dataSource: dataSource,
        editDirect: editDirect,
        editRow: editRow,
        eventHandlers: this.eventHandlers,
        key: "tableBody",
        rowAction: rowAction,
        rowAlerts: rowAlerts,
        rowExpand: rowExpand,
        rowKey: rowKey,
        rowSelection: rowSelection
      })));
    }
    /**
     * Render search input
     * @returns {ReactElement} Search input
     */

  }, {
    key: "renderSearch",
    value: function renderSearch() {
      var search = this.props.search;
      var inputProps = {};

      if (search.inputProps) {
        inputProps = search.inputProps;
      }

      return _react.default.createElement(_FlexLayout.default, {
        itemSpacing: "0px",
        alignItems: "center",
        key: "tableSearch",
        className: "table-search"
      }, _react.default.createElement(_Input.default, _extends({
        appearance: "nested",
        search: true,
        key: "tableSearchInput"
      }, inputProps)));
    }
    /**
     * Render pagination component
     * @returns {ReactElement} Pagination component
     */

  }, {
    key: "renderPagination",
    value: function renderPagination() {
      var _this$props8 = this.props,
          pagination = _this$props8.pagination,
          dataSource = _this$props8.dataSource,
          loading = _this$props8.loading;
      var hasOverlay = Boolean(loading); // If there is no data, don't render pagination

      if (dataSource && dataSource.length === 0) {
        return null;
      }

      var total = pagination.total;
      return _react.default.createElement(_Pagination.default, _extends({
        key: "tablePagination",
        disabled: hasOverlay
      }, pagination, {
        total: total,
        onChange: this.eventHandlers.handlePageChange
      }));
    }
    /**
     * Validate that column and row data have unique keys
     */

  }, {
    key: "validateKeys",
    value: function validateKeys() {
      var _this$props9 = this.props,
          columnKey = _this$props9.columnKey,
          columns = _this$props9.columns,
          dataSource = _this$props9.dataSource,
          rowKey = _this$props9.rowKey;
      columns.forEach(function (column) {
        if (typeof column[columnKey] === 'undefined') {
          throw new Error("There is a column that is missing a key: ".concat(JSON.stringify(column)));
        }
      });
      dataSource.forEach(function (data) {
        if (typeof data[rowKey] === 'undefined') {
          throw new Error("There is a dataSource that is missing a key: ".concat(JSON.stringify(data)));
        }
      });
    }
    /**
     * Handler for when user wants to refresh data
     */

  }, {
    key: "_handleEditDirectDataChange",

    /**
     * Handler for edit direct data changes
     * @param {string} value - New value that was changed
     * @param {object} rowData - Row data that is being changed
     * @param {column} column - Column where data is being changed
     * @param {string} eventType - event type to trigger direct data change
     * @private
     */
    value: function _handleEditDirectDataChange(value, rowData, column, eventType) {
      var _this$props10 = this.props,
          columnKey = _this$props10.columnKey,
          editDirect = _this$props10.editDirect,
          onBlurEditDirectData = _this$props10.onBlurEditDirectData,
          onChangeEditDirectData = _this$props10.onChangeEditDirectData,
          rowKey = _this$props10.rowKey;
      var columnKeyVal = column[columnKey];
      var newData = (0, _cloneDeep2.default)(this.props.dataSource);
      var newRowData;

      for (var i = 0; i < newData.length; i++) {
        if (newData[i][rowKey] === rowData[rowKey]) {
          newRowData = newData[i];
          newRowData[columnKeyVal] = value;
          break;
        }
      }

      var eventAction;

      if (eventType === 'onBlur' && onBlurEditDirectData) {
        eventAction = onBlurEditDirectData;
      } else if (eventType === 'onChange' && onChangeEditDirectData) {
        eventAction = onChangeEditDirectData;
      } // Fire the appropriately assigned eventAction depending on the eventType.


      if (eventAction) {
        var cellAlert = this._getErrorAlertForCell(newRowData, columnKeyVal, editDirect.columnConfigs[columnKeyVal].validations);

        var newCellAlerts = this.props.cellAlerts ? (0, _cloneDeep2.default)(this.props.cellAlerts) : [];
        var isNewCellAlert = true;

        for (var _i = 0; _i < newCellAlerts.length; _i++) {
          var newCellAlert = newCellAlerts[_i];

          if (newCellAlert.row === rowData[rowKey] && newCellAlert.column === columnKeyVal) {
            isNewCellAlert = false;

            if (cellAlert) {
              newCellAlerts[_i] = cellAlert;
            } else {
              // If cellAlert is not defined, but there is a cell alert in cellAlerts array,
              // we need to remove it from the array because the alert has been resolved
              newCellAlerts.splice(_i, 1);
            }

            break;
          }
        }

        if (isNewCellAlert && cellAlert) {
          newCellAlerts.push(cellAlert);
        } // Reset the cell alerts


        eventAction(newData, newCellAlerts, newRowData);
      }
    }
    /**
     * Get array of cell error alerts for a row
     * @param {Object} row - Data for row currently being edited
     * @returns {Array} - Array of cell error alerts
     * @private
     */

  }, {
    key: "_getErrorAlertsForRow",
    value: function _getErrorAlertsForRow(row) {
      var _this2 = this;

      var editRow = this.props.editRow;
      var cellAlerts = [];

      if (editRow.columnConfigs) {
        (0, _each2.default)(editRow.columnConfigs, function (columnConfig, columnKeyVal) {
          var cellAlert = _this2._getErrorAlertForCell(row, columnKeyVal, columnConfig.validations);

          if (cellAlert) {
            cellAlerts.push(cellAlert);
          }
        });
      }

      return cellAlerts;
    }
    /**
     * Get cell error alert for a cell
     * @param {Object} row - Data for row currently being edited
     * @param {string} columnKeyVal - Column key value for cell being edited
     * @param {Object} validations - Validation config for column
     * @returns {Object|undefined} - Cell alert object
     * @private
     */

  }, {
    key: "_getErrorAlertForCell",
    value: function _getErrorAlertForCell(row, columnKeyVal, validations) {
      var rowKey = this.props.rowKey;
      var cellValue = row[columnKeyVal];
      var cellAlert;

      if (validations) {
        (0, _each2.default)(validations, function (ruleArg, rule) {
          var isValid = _ValidationUtil.default.validate(cellValue, rule, ruleArg);

          if (!isValid) {
            cellAlert = {
              row: row[rowKey],
              column: columnKeyVal,
              type: _TableConstants.default.TABLE_ALERT.ERROR,
              message: validations.message
            };
            return false;
          }
        });
      }

      return cellAlert;
    }
    /**
     * Get rows to be selected/unselected as a result of shift key + click
     * @param {number} rowIndex - Index of row that was just clicked
     * @returns {Array} - Array of row keys that will get processed
     * @private
     */

  }, {
    key: "_getShiftClickRows",
    value: function _getShiftClickRows(rowIndex) {
      var _this$props11 = this.props,
          dataSource = _this$props11.dataSource,
          rowKey = _this$props11.rowKey;
      var shiftClickRows = [];
      var numRows = rowIndex - this.shiftClickRowIndex;
      var startIndex = this.shiftClickRowIndex;
      var endIndex = rowIndex;

      if (numRows < 0) {
        // Reverse the start and end index if numRows is negative
        startIndex = rowIndex;
        endIndex = this.shiftClickRowIndex;
      }

      for (var i = startIndex; i <= endIndex; i++) {
        shiftClickRows.push(dataSource[i][rowKey]);
      }

      return shiftClickRows;
    }
  }]);

  return Table;
}(_react.default.Component);

exports.default = Table;
Table.TABLE_ALERT = _TableConstants.default.TABLE_ALERT;
Table.ROW_SELECTION_TYPES = _TableRowSelection.ROW_SELECTION_TYPES;
Table.defaultProps = {
  border: true,
  columnKey: 'key',
  loading: false,
  rowKey: 'key'
};
Table.CELL_EDIT_TYPES = _TableCell.CELL_EDIT_TYPES;
Table.propTypes = {
  /**
   * Whether or not to show a table border
   */
  border: _propTypes.default.bool,

  /**
   * Array of cell alert configs
   */
  cellAlerts: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Row of cell
     */
    row: _propTypes.default.string,

    /**
     * Column of cell
     */
    column: _propTypes.default.string,

    /**
     * Type of cell alert (Use Table.TABLE\_ALERT constants)
     */
    type: _propTypes.default.oneOf([Table.TABLE_ALERT.ERROR, Table.TABLE_ALERT.WARNING]),

    /**
     * Alert message
     */
    message: _propTypes.default.string
  })),

  /**
   * className is used to add extra class for adding new style to override
   * default
   */
  className: _propTypes.default.string,

  /**
   * Unique key for a column. Each item in columns should have this defined
   */
  columnKey: _propTypes.default.string,

  /**
   * Array of column objects to use as the data for populating columns
   */
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Column title to be displayed
     */
    title: _propTypes.default.node,

    /**
     * Column key. This actually doesn't have to be key if columnKey prop
     * is defined
     */
    key: _propTypes.default.string,

    /**
     * Text alignment of column
     */
    textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),

    /**
     * Render function used to render cells
     * @param {Object} cellData - Data of cell to be rendered
     * @param {Object} rowData - Data of row to be rendered
     * @param {number} rowIndex - Index of row to be rendered
     * @returns {ReactElement}
     */
    render: _propTypes.default.func,

    /**
     * Array of column objects that will be grouped in the header
     */
    group: _propTypes.default.arrayOf(_propTypes.default.object)
  })).isRequired,

  /**
   * Config of custom messages to be displayed
   */
  customMessages: _propTypes.default.shape({
    /**
     * Custom node to display for loading error
     */
    loadingError: _propTypes.default.node,

    /**
     * Custom node to display when there is no data to be shown
     */
    noData: _propTypes.default.node,

    /**
     * Custom node to display when data is loading.
     */
    loadingMessage: _propTypes.default.node
  }),

  /**
   * Custom props to pass into table elements
   */
  customProps: _propTypes.default.shape({
    /**
     * Properties to pass to body td element.
     * See https://www.w3schools.com/tags/tag_td.asp for valid attributes
     * @param {Object} column - Data of column to assign properties
     * @param {Object} rowData - Data of row to assign properties
     * @param {number} rowIndex - Index of row to assign properties
     * @returns {Object} Props to be passed to td element
     */
    cellProps: _propTypes.default.func,

    /**
     * Properties to pass to th element.
     * See https://www.w3schools.com/tags/tag_th.asp for valid attributes
     * @param {Object} column - Data of column to assign properties
     * @returns {Object} Props to be passed to th element
     */
    headerProps: _propTypes.default.func,

    /**
     * Properties to pass to body tr element.
     * See https://www.w3schools.com/tags/tag_tr.asp for valid attributes
     * @param {Object} rowData - Data of row to assign properties
     * @param {number} rowIndex - Index of row to assign properties
     * @returns {Object} Props to be passed to tr element
     */
    rowProps: _propTypes.default.func
  }),

  /**
   * Array of objects to use as the data source for the table.
   * The object must contain attributes matching those specified in
   * columns array.
   * [{id: '123', ...data attributes},...]
   *
   */
  dataSource: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /**
   * Object with direct edit info. This allows edits directly in the table cell
   */
  editDirect: _propTypes.default.shape({
    /**
     * Config object. Apply shape to columnKey (column[columnKey]) e.g.
     * columnConfigs: {
     *   name: {
     *    inputProps: ...
     *   },
     *   age: {
     *    inputProps: ...,
     *    validations: ...
     *   },
     * }
     */
    columnConfigs: _propTypes.default.objectOf(_propTypes.default.shape({
      /**
       * Type of editable element (Use Table.CELL\_EDIT\_TYPES constants)
       */
      type: _propTypes.default.oneOf([// TODO: Remove INPUT_TEXT in 2.0
      Table.CELL_EDIT_TYPES.INPUT_TEXT, Table.CELL_EDIT_TYPES.INPUT, Table.CELL_EDIT_TYPES.SELECT]),

      /**
       * Props to be passed to Input component. See Input component for more details
       * @param {Object} cellData - Data of cell to assign properties
       * @param {Object} rowData - Data of row to assign properties
       * @param {number} rowIndex - Index of row to assign properties
       * @returns {Object} Props to be passed to select component
       */
      inputProps: _propTypes.default.func,

      /**
       * Props to be passed to Select component. See Select component for more details
       * @param {Object} cellData - Data of cell to assign properties
       * @param {Object} rowData - Data of row to assign properties
       * @param {number} rowIndex - Index of row to assign properties
       * @returns {Object} Props to be passed to select component
       */
      selectProps: _propTypes.default.func,

      /**
       * Render function used to render cells that are not editable.
       * If something is returned it will render it instead of the editable component
       * @param {Object} cellData - Data of cell to be rendered
       * @param {Object} rowData - Data of row to be rendered
       * @param {number} rowIndex - Index of row to be rendered
       * @returns {ReactElement}
       */
      render: _propTypes.default.func,

      /**
       * Validation config object
       */
      validations: _propTypes.default.shape({
        /**
         * Required validation rule
         */
        required: _propTypes.default.bool,

        /**
         * Is specific type validation rule
         */
        type: _propTypes.default.oneOf((0, _values2.default)(_ValidationUtil.default.TYPE)),

        /**
         * Message to display when validation fails
         */
        message: _propTypes.default.string
      })
    }))
  }),

  /**
   * Object with row edit info. This allows edits for one row and should be
   * triggered by some action done by the user
   */
  editRow: _propTypes.default.shape({
    /**
     * Config object
     */
    columnConfigs: _propTypes.default.objectOf(_propTypes.default.shape({
      /**
       * Type of editable element (Use Table.CELL\_EDIT\_TYPES constants)
       */
      type: _propTypes.default.oneOf([Table.CELL_EDIT_TYPES.INPUT_TEXT, Table.CELL_EDIT_TYPES.INPUT, Table.CELL_EDIT_TYPES.SELECT]),

      /**
       * Props to be passed to Input component. See Input component for more details
       * @param {Object} cellData - Data of cell to assign properties
       * @param {Object} rowData - Data of row to assign properties
       * @param {number} rowIndex - Index of row to assign properties
       * @returns {Object} Props to be passed to select component
       */
      inputProps: _propTypes.default.func,

      /**
       * Props to be passed to Select component. See Select component for more details
       * @param {Object} cellData - Data of cell to assign properties
       * @param {Object} rowData - Data of row to assign properties
       * @param {number} rowIndex - Index of row to assign properties
       * @returns {Object} Props to be passed to select component
       */
      selectProps: _propTypes.default.func,

      /**
       * Render function used to render cells that are not editable.
       * If something is returned it will render it instead of the editable component
       * @param {Object} cellData - Data of cell to be rendered
       * @param {Object} rowData - Data of row to be rendered
       * @param {number} rowIndex - Index of row to be rendered
       * @returns {ReactElement}
       */
      render: _propTypes.default.func,

      /**
       * Validation config object
       */
      validations: _propTypes.default.shape({
        /**
         * Required validation rule
         */
        required: _propTypes.default.bool,

        /**
         * Is specific type validation rule
         */
        type: _propTypes.default.oneOf((0, _values2.default)(_ValidationUtil.default.TYPE)),

        /**
         * Message to display when validation fails
         */
        message: _propTypes.default.string
      })
    })),

    /**
     * Row that is being edited
     */
    row: _propTypes.default.string,

    /**
     * Force to have overflow mode or not
     */
    overflow: _propTypes.default.bool
  }),

  /**
   * Set to true to show the loading indicator.
   */
  loading: _propTypes.default.bool,

  /**
   * Set to true to show the loading error.
   */
  loadingError: _propTypes.default.bool,

  /**
   * Callback executed when pagination has changed
   * @param {Object} pagination - Suggested pagination state
   * @param {number} nextPage - Suggested next page
   * @param {number} pageSize - Suggested page size
   */
  onChangePagination: _propTypes.default.func,

  /**
   * Callback executed when a cell is edited in editDirect mode. Triggered by onBlur event.
   * @param {Array} dataSource - Suggested dataSource state
   * @param {Object} cellAlerts - Suggested cellAlerts state
   * @param {Object} rowData - Row data that was changed
   */
  onBlurEditDirectData: _propTypes.default.func,

  /**
   * Callback executed when a cell is edited in editDirect mode. Triggered by onChange event.
   * @param {Array} dataSource - Suggested dataSource state
   * @param {Object} cellAlerts - Suggested cellAlerts state
   * @param {Object} rowData - Row data that was changed
   */
  onChangeEditDirectData: _propTypes.default.func,

  /**
   * Callback executed when row expand has changed
   * @param {Object} rowExpand - Suggested rowExpand state
   * @param {string} expanded - Row that was expanded
   * @param {string} collapsed - Row that was collapsed
   */
  onChangeRowExpand: _propTypes.default.func,

  /**
   * Callback executed when row selection has changed
   * @param {Object} rowSelection - Suggested rowSelection state
   * @param {Array} selected - List of newly selected rows
   * @param {Array} unselected - List of newly unselected rows
   */
  onChangeRowSelection: _propTypes.default.func,

  /**
   * Callback executed when sorting has changed
   * @param {Object} sort - Suggested sort state
   * @param {string} order - Suggested sort order
   * @param {string} column - Suggested sort column
   */
  onChangeSort: _propTypes.default.func,

  /**
   * Callback executed when table structure has changed
   * @param {Object} structure - Suggested structure state
   */
  onChangeStructure: _propTypes.default.func,

  /**
   * Callback executed when cancel is clicked in edit row mode
   * @param {Array} dataSource - Suggested dataSource state
   * @param {Object} editRow - Suggested editRow state
   * @param {Object} cellAlert - Suggested cellAlert state
   */
  onClickEditRowCancel: _propTypes.default.func,

  /**
   * Callback executed when submit is clicked in edit row mode
   * @param {Array} dataSource - Suggested dataSource state
   * @param {Object} editRow - Suggested editRow state
   * @param {Object} cellAlert - Suggested cellAlert state
   * @param {Object} rowData - Row data that was changed
   */
  onClickEditRowSubmit: _propTypes.default.func,

  /**
   * Callback executed when user requested to refresh data
   * @param {Object} state - Suggested state after data refresh
   */
  onRefreshData: _propTypes.default.func,

  /**
   * Pagination config. See Pagination component for more details
   */
  pagination: _propTypes.default.object,

  /**
   * Object with row action config
   */
  rowAction: _propTypes.default.shape({
    /**
     * Array of actions or Function used to generate list of actions for a row.
     * @param {Object} rowData - Data of row to display actions on
     * @param {number} rowIndex - Index of row to display actions on
     * @returns {Array} - actions array of objects with key and value properties
     */
    actions: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape({
      /**
       * Unique key for action
       */
      key: _propTypes.default.string,

      /**
       * Value to be displayed
       */
      value: _propTypes.default.string
    })), _propTypes.default.func]),

    /**
     * Function to execute when action has been triggered
     * @param {string} key - The key that triggered the action
     * @param {Object} rowData - Data of row to perform action on
     * @param {number} rowIndex - Index of row to perform action on
     */
    onRowAction: _propTypes.default.func,

    /**
     * Function to return a DOM element to use as container for the Overlay
     * Otherwise `<body>` is used
     * Mandatory if the Dropdown is in a scrollable container other than body
     * otherwise the Overlay won't scroll with the Dropdown
     */
    getPopupContainer: _propTypes.default.func
  }),

  /**
   * Array of row alert configs
   */
  rowAlerts: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Row of alert
     */
    row: _propTypes.default.string,

    /**
     * Type of row alert (Use Table.TABLE\_ALERT constants)
     */
    type: _propTypes.default.oneOf([Table.TABLE_ALERT.ERROR, Table.TABLE_ALERT.WARNING]),

    /**
     * Alert message
     */
    message: _propTypes.default.string
  })),

  /**
   * Object with expandable row config
   */
  rowExpand: _propTypes.default.shape({
    /**
     * If renderer produces a table, set this to true to get recommended
     * style for nested table for all rows or function that returns boolean
     * @param {Object} rowData - Data of row
     * @param {number} rowIndex - Index of row
     *
     */
    isNestedTable: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),

    /**
     * Renderer for expanded row
     * @param {Object} rowData - Data of row to render
     * @param {number} rowIndex - Index of row to render
     */
    render: _propTypes.default.func,

    /**
     * Currently expanded rows
     */
    rows: _propTypes.default.arrayOf(_propTypes.default.string)
  }),

  /**
   * Unique key for a row. Each item in dataSource should have this defined
   */
  rowKey: _propTypes.default.string,

  /**
   * Object with row selection config. If this is defined, rows will be selectable
   */
  rowSelection: _propTypes.default.shape({
    /**
     * List of rows that are selected
     */
    selected: _propTypes.default.arrayOf(_propTypes.default.string),

    /**
     * Type of row selection to be displayed (Use Table.ROW\_SELECTION\_TYPES constants)
     */
    type: _propTypes.default.oneOf([Table.ROW_SELECTION_TYPES.CHECKBOX, Table.ROW_SELECTION_TYPES.RADIO])
  }),

  /**
   * Object with search config. If this is defined, a searchable input will appear
   */
  search: _propTypes.default.shape({
    /**
     * See Input props for more details
     */
    inputProps: _propTypes.default.object
  }),

  /**
   * Object with sort info
   */
  sort: _propTypes.default.shape({
    /**
     * Current sorted order (Use Sorter.SORT\_ORDER\_CONST constants)
     */
    order: _propTypes.default.oneOf([_Sorter.default.SORT_ORDER_CONST.ASCEND, _Sorter.default.SORT_ORDER_CONST.DESCEND, _Sorter.default.SORT_ORDER_CONST.NONE]),

    /**
     * Current sorted column
     */
    column: _propTypes.default.string,

    /**
     * List of column keys for sortable columns
     */
    sortable: _propTypes.default.arrayOf(_propTypes.default.string),

    /**
     * See Sorter component for more details
     */
    type: _propTypes.default.string
  }),

  /**
   * Structure of table
   */
  structure: _propTypes.default.shape({
    /**
     * Max height of the table body. If content exceeds height, the header
     * will be fixed and body will be scrollable
     */
    bodyMaxHeight: _propTypes.default.string,

    /**
     * Whether or not columns can be resized
     */
    columnResize: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),

    /**
     * Hash map of column widths with column key for key and width for value
     */
    columnWidths: _propTypes.default.objectOf(_propTypes.default.string),

    /**
     * Whether or not to hide header
     */
    hideHeader: _propTypes.default.bool,

    /**
     * Position of pagination relative to table
     */
    paginationPosition: _propTypes.default.shape({
      /**
       * Render pagination on top of table
       */
      top: _propTypes.default.bool,

      /**
       * Render pagination on bottom of table
       */
      bottom: _propTypes.default.bool
    })
  }),
  topSection: _propTypes.default.shape({
    /**
     * Title of the table
     */
    title: _propTypes.default.string,

    /**
     * Custom content on left side of the top section.
     * If title exists, this will appear to the right of it
     */
    leftContent: _propTypes.default.node,

    /**
     * Custom content on right side of the top section.
     * If pagination exists, this will appear to the left of it
     */
    rightContent: _propTypes.default.node
  })
};